import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrustpilot = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M18 6.54183H11.1264L9.00332 0L6.87357 6.54183L0 6.5352L5.56653 10.5824L3.43679 17.1176L9.00332 13.077L14.5632 17.1176L12.4401 10.5824L18 6.54183Z",
			fill: "#00B67A"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.9178 12.0618L12.4401 10.5823L9.0033 13.0769L12.9178 12.0618Z",
			fill: "#005128"
		})
	]
});
const ForwardRef = forwardRef(SvgTrustpilot);
export { ForwardRef as ReactComponent };
